import {message, useIntl} from '@sail/intl';
import {view} from '@sail/ui';

import {useSelector} from 'src/fund/state/store';
import {Text} from 'src/v2/components/common/Text';
import {MEDIA_QUERIES} from 'src/v2/util/mediaQueries';

const messages = {
  title: message<{businessName: string}>({
    id: 'crypto.payins.fund.heading.pay_title',
    description: 'Title of the hosted crypto account funding card',
    defaultMessage: 'Pay {businessName}',
  }),
};

type ScreenContentLayoutProps = {
  children: React.ReactNode;
};

export const ScreenContentLayout = ({children}: ScreenContentLayoutProps) => {
  const intl = useIntl();
  const businessName = useSelector((state) => state.businessName);

  return (
    <view.div
      css={{
        stack: 'y',
        width: '388px',
        maxWidth: 'fill',
        minWidth: 'space.0',
        height: 'fit',
        gapY: 'large',
        backgroundColor: 'surface',
        boxShadow:
          '0px -4px 32px 0px rgba(0, 0, 0, 0.04), 0px 12px 32px 0px rgba(0, 0, 0, 0.04)',
        borderRadius: '20px',
        borderWidth: 'small',
        borderStyle: 'solid',
        borderColor: 'form',
        paddingX: 'large',
        paddingY: 'xlarge',
        [MEDIA_QUERIES.mediumWidth]: {
          width: 'fill',
          boxShadow: 'none',
          borderStyle: 'none',
          paddingX: '16px',
          paddingY: '16px',
        },
      }}
      data-testid="funding-screen-content-layout"
    >
      <view.div
        role="heading"
        aria-level={1}
        css={{stack: 'y', alignX: 'center', height: 'fit'}}
      >
        <Text
          type="labelEmphasized"
          css={{textAlign: 'center', overflowWrap: 'anywhere'}}
        >
          {intl.formatMessage(messages.title, {businessName})}
        </Text>
      </view.div>
      {children}
    </view.div>
  );
};
